import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-userreported',
    templateUrl: './userreportedlist.component.html',
     providers: [ SharedService,PopupSegmentComponent]
    // styleUrls: ['./dashboard.component.scss']

})
export class UsersReportedListComponent implements OnInit {

searchText ='';
data = [];
itemsTotalAdv = 0;
page =1;
searchSegText ='';
 objLoaderStatus: boolean = false;
 errormessage = '';
charFlag :boolean = false;
  message ="";
  searchmessage = "";
  id: number;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
     private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,private route : ActivatedRoute) {
    

    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

    var token = this.localstorage.getStorage("token");
        this.loaderService.displayLoader(true);
this.route.params.subscribe(params => {
    this.id = Number.parseInt(params['id']);
});
  this.shareService.CallDatawithToken("admin/campaignReportingUser/"+this.id+"?currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
            this.loaderService.displayLoader(false);

    }
         });


    }

  
   nextSegment(event){
this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
     var token = this.localstorage.getStorage("token");

               this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/campaignReportingUser/"+this.id+"?currentPage="+event+"&currentSize=25", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    this.loaderService.displayLoader(false);

    }
         });
    return event;            
}

sortTable(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("myTable2");
  switching = true;
  dir = "asc"; 

  while (switching) {
    switching = false;
    rows = table.getElementsByTagName("TR");
   
    for (i = 1; i < (rows.length - 1); i++) {
      shouldSwitch = false;
     
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
   
      if (dir == "asc") {
        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
          shouldSwitch= true;
          break;
        }
      } else if (dir == "desc") {
        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
          shouldSwitch= true;
          break;
        }
      }
    }
    if (shouldSwitch) {
     
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      switchcount ++; 
    } else {
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}


         
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/reportedContent/userreportedlist.component.ts